<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BRow>
      <BCol
        cols="12"
      >
        <TaskMoreDetails
          class="mt-3 mb-2"
          :more-details="1"
          :activity="{
            activity_name: taskInformation.activity_name,
            crop_name: taskInformation.crop_name,
            total_buyers: taskInformation.customers_bought_count
          }"
          :current-progress="{
            event: taskInformation.events_count,
            customer: taskInformation.customers_attended_count,
            hectare: taskInformation.total_actual_hectares,
            cost: taskInformation.total_actual_costs,
            sales: taskInformation.total_actual_sales
          }"
          :total-progress="{
            event: taskInformation.event_plan,
            customer: taskInformation.total_customer_plan,
            hectare: taskInformation.total_hectare_plan,
            cost: taskInformation.total_budget_plan,
            sales: taskInformation.total_sales_plan
          }"
          :loading="state.busy"
        >
          <template #footer-loader>
            <div class="d-flex justify-content-start gap-2 mt-3">
              <BSkeleton
                width="62px"
                height="20px"
              />
            </div>
          </template>
          <template #footer>
            <div class="d-flex justify-content-start gap-2 mt-3">
              <BBadge variant="dark-light">
                {{ monthShortFormatter(taskInformation.schedule) }}
              </BBadge>
            </div>
          </template>
        </TaskMoreDetails>
      </BCol>
    </BRow>
    <Events
      v-if="taskInformation.id"
      :task="taskInformation"
    />
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import TaskMoreDetails from '@/views/fso/task-events/components/TaskMoreDetails.vue'
import Events from '@/views/fso/task-events/Events.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MxImageUrl from '@/mixins/image-url'
import MCustomers from '@/mixins/accounts/customers'

import { SFSOTask } from '@/services/fso'

export default {
  name: 'FSOTaskEventsBase',

  midddleware: [
    'auth',
    'fso'
  ],

  components: {
    Events,
    TaskMoreDetails
  },

  mixins: [
    MCustomers,
    MxMisc,
    MxFormatter,
    MxImageUrl
  ],

  metaInfo: () => ({
    title: 'Task Events'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false,
        fetching: false
      },
      taskInformation: {
        id: '',
        activity_id: '',
        activity_name: '',
        assignee_id: '',
        customer_per_event: 0,
        target_hectare: 0,
        budget_per_event: 0,
        crop_id: '',
        crop_name: '',
        schedule: '',
        conversion_rate: 0.00,
        customers_bought_count: 0,
        events_count: 0,
        customers_attended_count: 0,
        total_actual_hectares: 0,
        total_actual_costs: 0,
        total_actual_sales: 0,
        event_plan: 0,
        total_customer_plan: 0,
        total_hectare_plan: 0,
        total_budget_plan: 0,
        total_sales_plan: 0,
        rules: {
          customer: 0,
          barangay: 1,
          actual_hectares: 0,
          customer_attended: 0,
          actual_costs: 0,
          customer_bought: 0,
          actual_sales: 0,
          customer_bookings: 0,
          booking_sales: 0
        },
        documents: [],
        active: 1
      },
      gridLogs: {
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10
      }
    }
  },

  computed: mapGetters({
    currentUser: 'auth/user'
  }),

  mounted () {
    if (this.currentUser) {
      this.getTask()
    }
  },

  methods: {

    async getTask () {
      this.state.busy = true
      return SFSOTask.show(this.$route.params.task).then(
        async ({ data: { task } }) => {
          if (!task) {
            return this.swalInvalid(
              '<h6>Officer task seems to be incorrect or incomplete, please check and try again.</h6>',
              'Task Not Found'
            ).then(
              () => {
                this.$router.push({
                  name: 'asm.officers.tasks',
                  params: {
                    officer: this.officer.id
                  }
                })
              }
            )
          }

          this.taskInformation = Object.assign(this.taskInformation, {
            id: task.id,
            activity_id: task.activity_id,
            activity_name: task.activity?.activity_name || '',
            customer_per_event: task.activity?.customer_per_event || 0,
            target_hectare: task.activity?.target_hectare || 0,
            budget_per_event: task.activity?.budget_per_event || 0,
            assignee_id: task.assignee_id,
            conversion_rate: task?.conversion_rate || 0.00,
            customers_bought_count: task?.customers_bought_count || 0,
            events_count: task?.events_count || 0,
            customers_attended_count: task?.customers_attended_count || 0,
            total_actual_hectares: task?.total_actual_hectares || 0,
            total_actual_costs: task?.total_actual_costs || 0,
            total_actual_sales: task?.total_actual_sales || 0,
            event_plan: task?.event_plan || 0,
            total_customer_plan: task?.total_customer_plan || 0,
            total_hectare_plan: task?.total_hectare_plan || 0,
            total_budget_plan: task?.total_budget_plan || 0,
            total_sales_plan: task?.total_sales_plan || 0,
            rules: Object.assign({
              customer: 0,
              barangay: 1,
              actual_hectares: 0,
              customer_attended: 0,
              actual_costs: 0,
              customer_bought: 0,
              actual_sales: 0,
              customer_bookings: 0,
              booking_sales: 0
            }, task.activity?.rules || {}),
            documents: Array.from(task?.activity?.documents || []).sort((a, b) => Number(b.required) - Number(a.required)),
            schedule: task.schedule
          })
        }
      ).finally(() => {
        this.state.busy = false
      })
    }
  }
}
</script>
